<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Conquérir l’héritier</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">Par Julia Talbot</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Est-il amoureux d’un vieil hôtel… ou de son nouveau propriétaire ?</p>
<p class="P_Normal">Le snowboardeur professionnel Cullen Patrick a du succès et est plutôt célèbre. Donc, lorsqu’il hérite d’un vieil hôtel dans le Colorado d’un parent inconnu, il devrait vraiment laisser tomber.</p>
<p class="P_Normal">Matt Nathanson gère le <span style=" font-style: italic; font-size: 1.00em;">Treeline Estate</span> depuis sa sortie de l’université. Il adorait l’ancien propriétaire et héritera de l’endroit si personne ne le réclame d’ici la semaine prochaine. Bien sûr, Cullen se montre et Matt pense qu’il est temps de passer à autre chose. Il ne veut pas aimer cet homme, peu importe à quel point il est attachant ou à quel point il est affamé.</p>
<p class="P_Normal">Cullen a de grandes idées pour le <span style=" font-style: italic; font-size: 1.00em;">Treeline</span>, mais il ne veut pas les lancer sans Matt et il n’est pas sûr d’être prêt à abandonner le snowboard. Matt peut-il le convaincre que s’enraciner en vaut la peine… et peut-être conquérir son héritier en même temps ?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?10238f68